import { useEffect, useMemo } from 'react';

import _ from 'lodash';

const useContentFormChanged = ({
  deletedRecords,
  entitiesSideData,
  hasDirtyCustomFields,
  initialEntitiesSideData,
  isFormDirty,
  newRecords,
  setIsFormChanged,
}) => {
  const isSideDataChanged = useMemo(
    () => !_.isEqual(initialEntitiesSideData, entitiesSideData),
    [initialEntitiesSideData, entitiesSideData],
  );

  const isFormChanged =
    isFormDirty ||
    isSideDataChanged ||
    !!deletedRecords.size ||
    !!newRecords.length ||
    hasDirtyCustomFields;

  useEffect(() => {
    setIsFormChanged(isFormChanged);
  }, [isFormChanged, setIsFormChanged]);
};

export default useContentFormChanged;
